var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "shopping-basket-full" }, [
    _c(
      "div",
      { staticClass: "row flex justify-center" },
      [
        _c(
          "transition-group",
          {
            staticClass: "xl:w-10/12 relative w-full",
            attrs: { name: "component-fade", mode: "out-in", tag: "div" }
          },
          [
            !_vm.ready
              ? _c(
                  "div",
                  {
                    key: "loading",
                    staticClass:
                      "lg:mt-120 left-1/2 absolute top-0 flex items-center justify-center flex-1 mt-40 transform -translate-x-1/2"
                  },
                  [_c("spinner")],
                  1
                )
              : this.basket.products.length > 0
              ? _c("div", { key: "not-empty", staticClass: "not-empty" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex flex-col items-stretch justify-between flex-1"
                    },
                    [
                      _c("h1", { staticClass: "mb-24 text-gray-800" }, [
                        _vm._v(_vm._s(_vm.translations.shopping_basket_title))
                      ]),
                      _vm._v(" "),
                      _c(
                        "transition",
                        { attrs: { name: "component-fade", mode: "out-in" } },
                        [
                          _vm.bannerOpen && _vm.$store.getters["isReseller"]
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "rounded-xs relative p-24 mb-24 bg-gray-100"
                                },
                                [
                                  _c("div", {
                                    staticClass: "close",
                                    on: {
                                      click: function($event) {
                                        _vm.bannerOpen = false
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    { staticClass: "text-20 mb-8 font-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.translations.reseller_discount
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("p", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.translations.reseller_discount_description.replace(
                                          /\{{(.+?)\}}/g,
                                          _vm.$store.getters["percentage"]
                                        )
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "relative" },
                        _vm._l(this.basket.products, function(product) {
                          return _c(
                            "div",
                            {
                              key: product.id,
                              staticClass:
                                "last:pb-0 last:mb-0 last:border-transparent flex flex-wrap pb-24 mb-24 border-b border-gray-300"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "lg:w-1/2 flex w-full",
                                  class: {
                                    "opacity-50":
                                      product.amount >
                                      _vm.getAvailableVariantStock(
                                        product.variant
                                      )
                                  }
                                },
                                [
                                  _c("img", {
                                    staticClass:
                                      "w-60 h-60 md:w-80 md:h-80 rounded-xs object-cover object-center mr-16",
                                    attrs: {
                                      src: _vm.getFirstImage(
                                        product.productData
                                      ),
                                      alt: product.productData.name
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "lg:py-8 lg:pr-16 flex flex-col flex-1"
                                    },
                                    [
                                      _c("p", {
                                        staticClass:
                                          "text-20 whitespace-nowrap title overflow-ellipsis min-w-0 mb-8 overflow-hidden font-bold leading-6 text-gray-800",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            product.productData.name
                                          )
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "flex items-center" },
                                        [
                                          _vm._l(
                                            product.productData.options.filter(
                                              function(o) {
                                                return o.type !== "opp_calc"
                                              }
                                            ),
                                            function(option) {
                                              return [
                                                _c(
                                                  "span",
                                                  {
                                                    key: option.key,
                                                    staticClass:
                                                      "text-14 font-medium leading-tight text-gray-500"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        product.variant.content[
                                                          option.key
                                                        ]
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    key: option.key + "_bull",
                                                    staticClass:
                                                      "text-10 mx-8 font-medium text-gray-500"
                                                  },
                                                  [_vm._v("•")]
                                                )
                                              ]
                                            }
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "text-14 hover:border-transparent font-medium leading-tight text-gray-500 transition-colors border-b border-gray-500",
                                              attrs: {
                                                href:
                                                  "/product/" +
                                                  product.productData.slug
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.translations.view_product
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        2
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "lg:w-1/2 lg:pt-0 flex items-start justify-between w-full pt-16"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "flex items-center" },
                                    [
                                      _vm.getAvailableVariantStock(
                                        product.variant
                                      ) === 0
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "lg:mr-56 lg:pt-8 mr-32",
                                              staticStyle: { width: "140px" }
                                            },
                                            [
                                              _c(
                                                "p",
                                                { staticClass: "text-red" },
                                                [_vm._v("Niet voorradig")]
                                              )
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "lg:mr-40 flex flex-col mr-16"
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "lg:pt-8 flex" },
                                                [
                                                  _c("a", {
                                                    staticClass: "decrease",
                                                    class: {
                                                      "text-gray-200 cursor-default":
                                                        product.amount <= 1
                                                    },
                                                    attrs: { href: "#" },
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.svg("minus")
                                                      )
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        $event.preventDefault()
                                                        return _vm.decreaseAmount(
                                                          product
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("input", {
                                                    staticClass:
                                                      "add-amount text-center appearance-none",
                                                    attrs: { type: "number" },
                                                    domProps: {
                                                      value: product.amount
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        return _vm.updateAmount(
                                                          $event,
                                                          product
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("a", {
                                                    staticClass: "increase",
                                                    class: {
                                                      "text-gray-200 cursor-default":
                                                        product.amount >=
                                                        _vm.getAvailableVariantStock(
                                                          product.variant
                                                        )
                                                    },
                                                    attrs: { href: "#" },
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.svg("plus")
                                                      )
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        $event.preventDefault()
                                                        return _vm.increaseAmount(
                                                          product
                                                        )
                                                      }
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              product.amount >
                                              _vm.getAvailableVariantStock(
                                                product.variant
                                              )
                                                ? _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "text-red text-14 mt-8"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Slechts " +
                                                          _vm._s(
                                                            _vm.getAvailableVariantStock(
                                                              product.variant
                                                            )
                                                          ) +
                                                          " op voorraad"
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          ),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "text-14 hover:border-transparent font-medium leading-tight text-gray-500 transition-colors border-b border-gray-500",
                                          attrs: { href: "#" },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.removeProduct(
                                                product.variant.id
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.translations.remove)
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "lg:pt-8 flex flex-col items-end flex-shrink-0 text-right",
                                      class: {
                                        "opacity-50 pointer-events-none line-through":
                                          product.amount >
                                          _vm.getAvailableVariantStock(
                                            product.variant
                                          )
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "text-20 mb-8 font-bold text-gray-800"
                                        },
                                        [
                                          _vm._v(
                                            "€ " +
                                              _vm._s(
                                                _vm.formatCurrency(
                                                  _vm.getVariantPrice(
                                                    product,
                                                    true
                                                  ) * product.amount
                                                )
                                              )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "text-14 font-medium leading-tight text-gray-500"
                                        },
                                        [
                                          _vm._v(
                                            "€ " +
                                              _vm._s(
                                                _vm.formatCurrency(
                                                  _vm.getVariantPrice(
                                                    product,
                                                    false
                                                  ) * product.amount
                                                )
                                              ) +
                                              " excl. btw"
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "border-dark flex flex-row justify-end pt-40 mt-40 border-t"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "lg:w-5/12 lg:w-1/2 w-full" },
                            [
                              _c(
                                "div",
                                { staticClass: "flex justify-between mb-8" },
                                [
                                  _c("span", { staticClass: "text-black" }, [
                                    _vm._v(_vm._s(_vm.translations.subtotal))
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "text-gray-500" }, [
                                    _vm._v("€ " + _vm._s(_vm.subTotal))
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "flex justify-between mb-8" },
                                [
                                  _c("span", { staticClass: "text-black" }, [
                                    _vm._v(_vm._s(_vm.translations.vat))
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "text-gray-500" }, [
                                    _vm._v("€ " + _vm._s(_vm.vat))
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "flex justify-between mb-24" },
                                [
                                  _c("span", { staticClass: "text-black" }, [
                                    _vm._v(_vm._s(_vm.translations.shipping))
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "text-gray-500" }, [
                                    _vm._v("Volgende stap")
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "flex justify-between mb-24" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text-20 font-bold text-black"
                                    },
                                    [_vm._v(_vm._s(_vm.translations.total))]
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "text-gray-500" }, [
                                    _vm._v("€ " + _vm._s(_vm.totalPrice))
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "flex items-center mb-24" },
                                [
                                  _vm.$store.getters["basketErrors"].length &&
                                  _vm.$store.getters["basketErrors"].find(
                                    function(e) {
                                      return [
                                        "out_of_stock",
                                        "not_enough_stock"
                                      ].includes(e.issue)
                                    }
                                  )
                                    ? _c(
                                        "tooltip",
                                        {
                                          staticClass: "w-full",
                                          attrs: {
                                            text:
                                              _vm.translations
                                                .shopping_basket_stock_error
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "btn btn-rounded w-full text-center text-white border-none pointer-events-none",
                                              staticStyle: {
                                                "background-color":
                                                  "rgba(35, 179, 47, 0.6)"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.translations.submit_button
                                                )
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "bg-red text-12 inline-flex items-center justify-center w-16 h-16 ml-16 font-bold text-white rounded-full"
                                                },
                                                [_vm._v("!")]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm.$store.getters["basketErrors"]
                                        .length &&
                                      _vm.$store.getters["basketErrors"].find(
                                        function(e) {
                                          return (
                                            e.issue === "order_amount_too_low"
                                          )
                                        }
                                      )
                                    ? _c(
                                        "tooltip",
                                        {
                                          staticClass: "w-full",
                                          attrs: {
                                            text: _vm.translations.order_amount_too_low.replace(
                                              /\{{(.+?)\}}/g,
                                              _vm.$store.getters["customer"]
                                                .min_order_amount
                                            )
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "btn btn-rounded w-full text-center text-white border-none pointer-events-none",
                                              staticStyle: {
                                                "background-color":
                                                  "rgba(35, 179, 47, 0.6)"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.translations.submit_button
                                                )
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "bg-red text-12 inline-flex items-center justify-center w-16 h-16 ml-16 font-bold text-white rounded-full"
                                                },
                                                [_vm._v("!")]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _c(
                                        "a",
                                        {
                                          staticClass:
                                            "btn btn-green btn-rounded w-full text-center",
                                          attrs: { href: "/checkout" }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.translations.submit_button
                                            )
                                          )
                                        ]
                                      )
                                ],
                                1
                              )
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mb-80 lg:mb-120 lg:mt-80 mt-40" },
                    [_vm._t("default")],
                    2
                  )
                ])
              : _c(
                  "div",
                  {
                    key: "empty",
                    staticClass: "mb-160 lg:mb-200 lg:mt-60 mt-16 text-center"
                  },
                  [
                    _c("h1", { staticClass: "h2 mb-16" }, [
                      _vm._v(_vm._s(_vm.translations.shopping_basket_title))
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "mb-40" }, [
                      _vm._v(_vm._s(_vm.translations.empty_basket))
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-rounded btn-lg btn-outline-blue",
                        attrs: { href: "/producten" }
                      },
                      [_vm._v(_vm._s(_vm.translations.continue_shopping))]
                    )
                  ]
                )
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }